import flattenHierarchy from "backend/flattenHierarchy";
import { ICardElementWithChildren } from "backend/model/model";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import { PerspectiveCard } from "../cards/PerspectiveCard";
import { StackedKpiInitiative } from "../charts/StackedKpiInitiative";
import { IChartSelectEvent } from "../charts/types";
import PerspectiveHeader from "../texts/PerspectiveHeader";
import PerspectiveName from "../texts/PerspectiveName";

const useElementOverviewStackedCardStyles = makeThemedStyles(
  "ElementOverviewStackedCard",
  (theme) => ({
    root: {
      width: "30.4em",
      minHeight: "37.1em",
      fontSize: "10px",
      borderRadius: ".8em",
      border: "1px solid rgba(247, 247, 247, 1)",
    },
    divider: {
      height: "20px",
    },
  })
);

export const ElementOverviewStackedCard = React.memo(
  (
    props: React.PropsWithChildren<{
      element: ICardElementWithChildren;
      translatedName: string;
      periodName: string;
      title: string;
      typenames: string[];
      onSelect?: (value: IChartSelectEvent) => void;
    }>
  ) => {
    const { element: el } = props;
    const styles = useElementOverviewStackedCardStyles();
    return (
      <PerspectiveCard>
        <PerspectiveHeader title={props.title} periodName={props.periodName} />
        <PerspectiveName>{props.translatedName}</PerspectiveName>
        <div className={styles.divider} />
        <StackedKpiInitiative
          element={flattenHierarchy(el.children).filter(
            (ch) => props.typenames.includes(ch.typename) && ch.STATUS === "1"
          )}
          perfColorKey="rangecolor"
          perfNameKey="rangename"
          typenames={props.typenames}
          onSelect={props.onSelect}
        />
      </PerspectiveCard>
    );
  }
);
